import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent implements OnInit {

  @Input() accountCreatedImgSrc: string;
  @Input() accountCreatedText: string;

  constructor() { }

  ngOnInit() {
  }

}
